import { useQuery } from "@tanstack/react-query";
import { useLoginContext } from "../../../App";
import { fetchMeasurementUnitsData } from "../../../services/b2b-indicators-apiService";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { showNotification } from "../../b2b-common/Notification";
import { useContentContext } from "../../layout/Layout";

const useMeasurementUnits = () => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-indicators');

    const getMeasurementUnits = async () => {
        try {
            const data = await fetchMeasurementUnitsData(loginData.accessToken);
            return data;
        } catch (error) {
            showNotification(setNotification, t('Error fetching measurement units'), 'error', 5000);
        }
    }

    const { data: measurementUnits } = useQuery({
        queryKey: ['measurementUnits'],
        queryFn: () => getMeasurementUnits(),
    });

    return measurementUnits;
}

export default useMeasurementUnits;